<h2 mat-dialog-title>Modifier un forfait</h2>
<mat-dialog-content>
    <form [formGroup]="packageForm">
        <mat-form-field class="w-full">
            <mat-label>Nom</mat-label>
            <input matInput type="text" formControlName="name">
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Description</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" formControlName="description"></textarea>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type">
                @for (packageType of packageTypes; track packageType.value) {
                <mat-option [value]="packageType.value">{{packageType.label}}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if (packageForm.get('type')?.value == 'monthly') {
        <mat-form-field class="w-full">
            <mat-label>Limite de consommation</mat-label>
            <input matInput type="number" formControlName="limit">
            <span matTextSuffix> heures</span>
        </mat-form-field>
        }

        <mat-form-field class="w-full">
            <mat-label>Niveau de priorité</mat-label>
            <input matInput type="number" formControlName="priority_level">
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]>Annuler</button>
    <button matButton (click)="submit()">Valider</button>
</mat-dialog-actions>